// AUTOGENERIERT von scripts/optimize-images.py — nicht von Hand ändern.
// Basenamen der Bilder, die die App lokal als WebP ausliefert.
export const OPTIMIZED_ASSETS = new Set<string>([
  "02",
  "band",
  "bg01",
  "bg03",
  "bg04",
  "bg06",
  "bg07",
  "bg10",
  "bg12",
  "bg14",
  "bg14-flip-y",
  "bg16",
  "bg17",
  "bg18",
  "dawn",
  "hero",
  "logo-full",
  "logo-icon",
  "texture",
]);
